import { render, staticRenderFns } from "./StarRatingLight.vue?vue&type=template&id=5beee74c"
import script from "./StarRatingLight.vue?vue&type=script&lang=js"
export * from "./StarRatingLight.vue?vue&type=script&lang=js"
import style0 from "./StarRatingLight.vue?vue&type=style&index=0&id=5beee74c&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports